import { ReactSVG } from "react-svg";

const WidgetIconFive = ({ iconProp, widthIconProp, heightIconProp }) => {
  return (
    <ReactSVG
      src={iconProp}
      beforeInjection={(svg) => {
        svg.setAttribute("width", widthIconProp);
        svg.setAttribute("height", heightIconProp);
        svg.setAttribute("style", "overflow: visible;");
      }}
    />
  );
};

export default WidgetIconFive;
